import { render, staticRenderFns } from "./custom-footer.vue?vue&type=template&id=6a534f88"
import script from "./custom-footer.vue?vue&type=script&setup=true&lang=ts"
export * from "./custom-footer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports